import { publicEnvironment } from "./public-env";

const normalize = (value: string | undefined) => value?.replace(/\/+$/, "");

export function artPublicBaseUrl() {
  const runtime =
    typeof process === "undefined" ? undefined : process.env.ART_PUBLIC_BASE_URL;
  return normalize(
    runtime === undefined ? publicEnvironment("VITE_ART_BASE_URL") : runtime,
  );
}

export function artworkUrl(tokenId: number | string) {
  const base = artPublicBaseUrl();
  if (!base) return `/api/art/${tokenId}`;
  return `${base}/images/${String(tokenId).padStart(4, "0")}.webp`;
}

export function tokenMetadataUrl(tokenId: number | string) {
  const base = artPublicBaseUrl();
  if (!base) return `/api/metadata/${tokenId}`;
  return `${base}/metadata/${String(tokenId).padStart(4, "0")}.json`;
}
